














import axios from 'axios';
import Vue from 'vue';
import HotelBooking from '@/components/HotelBooking.vue';
import { IHotel } from '@/types';

export default Vue.extend({
  name: 'HotelPage',
  components: {
    HotelBooking,
  },
  data: () => ({
    hotelData: null,
  }),
  computed: {
    hotelId(): number {
      return +this.$route.params.id;
    },
    hotel(): IHotel {
      return this.hotelData ? this.hotelData : [];
    },
  },
  methods: {
    loadHotel(): void {
      axios
        .get(`https://jsonplaceholder.typicode.com/posts/${this.hotelId}`)
        .then(response => {
          this.hotelData = response.data;
        })
        .catch(error => console.log(error));
    },
  },
  created() {
    this.loadHotel();
  },
});
